import { lazy } from 'react';

const COMPONENT_CACHE = {};

export const getPageComponent = (routeName) => {
    // Гарантируем, что компонент lazy() создается только один раз
    if (COMPONENT_CACHE[routeName]) {
        return COMPONENT_CACHE[routeName];
    }
    const LazyComponent = lazy(() => import(`components/pages/${routeName}`));
    COMPONENT_CACHE[routeName] = LazyComponent;
    return LazyComponent;
};
